import { render, staticRenderFns } from "./account-su-updates-update.html?vue&type=template&id=39e70768&scoped=true&external"
import script from "./account-su-updates-update.js?vue&type=script&lang=js&external"
export * from "./account-su-updates-update.js?vue&type=script&lang=js&external"
import style0 from "./account-su-updates-update.scss?vue&type=style&index=0&id=39e70768&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e70768",
  null
  
)

export default component.exports